import {initWebComponent} from "@/helpers/web-component-helper";
import {setActiveFilter} from "@/helpers/filter/filter-helper";
import {setActiveMutation} from "@/helpers/tools/tools-mutation-helper";
import {hideLayerInfoForm, initHideButton} from "@/helpers/layer/info/layer-info-helper";

const template = document.createElement('template');
template.innerHTML = `<button class="btn btn-sm btn-outline-secondary text-transform-none btn-block popper-header" type="button">
            <i class="fa fa-bookmark"></i> Bookmarks
             <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
                 Bookmarks beheren
                <div class="arrow" data-popper-arrow=""></div>
              </div>
          </button>`;

export class LayerMenuButtonSession extends HTMLElement{
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            const element = document.querySelectorAll('bookmark-session')[0]
            const classList = [...element.classList]

            hideLayerInfoForm()

            if(classList.includes('d-none')) {
                element.classList.remove('d-none')
                element.parentNode.classList.remove('d-none')
            }

            initHideButton()
        })
    }
}
